module.exports = __webpack_public_path__ + "media/images/thanksgiving/bg-xs-fe327bbbe0b7b729dadb88669c46b808.jpg";